export default __webpack_public_path__ + "static/media/orange-1.b034a776.png";